const validTimestamp = value => (
  typeof value === 'string' && value.trim() && Number.isFinite(Date.parse(value))
    && !/^0001-01-01T00:00:00(?:\.0+)?(?:Z|\+00:00)$/.test(value)
    ? value : undefined
);

const earliest = values => values.map(validTimestamp).filter(Boolean).reduce(
  (result, value) => (!result || Date.parse(value) < Date.parse(result) ? value : result),
  undefined,
);

// Use only this version's recipient-scoped locations. A total cancellation
// retains their original validity start; issuance is never a validity fallback.
export const publicWarningStartTime = (warning = {}) => {
  // An explicit null is an authoritative unknown, not an old API response.
  if (warning.validTime !== undefined) {
    return validTimestamp(warning.validTime);
  }
  const geoText = warning.geoText || {};
  const geo = warning.geo || {};
  const active = ['new', 'update', 'continue'];
  const buckets = active.some(bucket => (
    (geoText[bucket] || []).length || (geo[bucket] || []).length
  )) ? active : ['cancel'];

  const values = buckets.reduce((times, bucket) => {
    const textTimes = (geoText[bucket] || [])
      .map(entry => validTimestamp(entry && entry.validTime)).filter(Boolean);
    const geoTimes = (geo[bucket] || [])
      .map(feature => feature && feature.properties && feature.properties.validTime);
    return times.concat(textTimes.length ? textTimes : geoTimes);
  }, []);

  return earliest(values);
};

export const publicWarningEventStartTime = (details = {}) => (
  details.validTime !== undefined
    ? validTimestamp(details.validTime)
    : publicWarningStartTime(details.warnings && details.warnings[details.warnings.length - 1])
);
